document.addEventListener('turbo:load', () => {
  const inquirySubmitButton = document.querySelector('#inquiry-submit-button')
  if (inquirySubmitButton) {
    const messageInput = document.querySelector('#inquiry-message')
    messageInput.addEventListener('input', () => { inquirySubmitButton.disabled = messageInput.value.length === 0 })
  }

  const manualUploadButton = document.querySelector('#manual-upload-button')
  if (manualUploadButton) {
    const fileInput = document.querySelector('#manual-field')
    fileInput.addEventListener('change', () => {
      manualUploadButton.disabled = fileInput.files.length === 0
    })
  }

  if (window.__inquiryScreenshotSizeLimitInitialized) return
  window.__inquiryScreenshotSizeLimitInitialized = true
  function onReady(){
    var input = document.getElementById('inquiry-screenshot')
    if (!input) return
    var errorEl = document.getElementById('inquiry-screenshot-error')
    var MAX = 10 * 1024 * 1024 // 10MB

    function validate(){
      var file = input.files && input.files[0]
      var msg = ''
      if (file && file.size > MAX) {
        msg = 'ファイルサイズは10MB以下にしてください。'
      }
      input.setCustomValidity(msg)
      if (msg) {
        input.classList.add('is-invalid')
        if (errorEl) {
          errorEl.textContent = msg
          errorEl.style.display = ''
        }
      } else {
        input.classList.remove('is-invalid')
        if (errorEl) {
          errorEl.textContent = ''
          errorEl.style.display = 'none'
        }
      }
    }

    input.addEventListener('change', validate)
    validate()
  }
  document.addEventListener('turbo:load', onReady)
  document.addEventListener('DOMContentLoaded', onReady)
})
